export default class InvalidOperationException extends Error {
	
	constructor(message?: string) {
		super(`InvalidOperationException ${message}`);
	}
}
